<template>
  <path
    d="M13.2799 3.78344L7.26462 0.578053C7.07729 0.473982 6.84833 0.473982 6.661 0.578053L0.833027 3.78344C0.624885 3.88751 0.5 4.09565 0.5 4.32461V8.86211C0.5
    12.4213 2.62305 15.6683 5.89088 17.1045L6.70263 17.4584C6.78589 17.5 6.86915 17.5 6.9524 17.5C7.03566 17.5 7.11892 17.4792 7.20217 17.4584L8.118 17.0629C11.4483
    15.6475 13.6129 12.4005 13.6129 8.77885V4.32461C13.6129 4.09565 13.4881 3.88751 13.2799 3.78344ZM10.1994 8.19605L6.51531 11.1933C6.39042 11.2974 6.26553 11.339
    6.11983 11.339C5.95332 11.339 5.76599 11.2557 5.64111 11.11L4.05923 9.25757C3.83027 8.98699 3.8719 8.59152 4.12167 8.38338C4.39226 8.15442 4.78773 8.19605 4.99587
    8.44582L6.18228 9.84037L9.38766 7.21778C9.65825 7.00964 10.0537 7.03046 10.2619 7.30104C10.5116 7.59244 10.47 7.98791 10.1994 8.19605Z"
  />
</template>
